import styled from '@emotion/styled';

export const StopHeader = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: flex-start;
    padding: 16px;
    border-bottom: 1px solid #e8e8e8;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
`;

export const StopMeta = styled.div`
    padding: 16px;
    border-bottom: 1px solid #f0f0f0;
`;

export const StopType = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;

    .transport-icon {
        color: ${(props) => (props.provider === 'metro' ? '#1976d2' : '#388e3c')};
    }

    .provider-badge {
        background: ${(props) => (props.provider === 'metro' ? '#1976d2' : '#388e3c')};
        color: white;
        padding: 4px 8px;
        border-radius: 12px;
        font-size: 11px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }

    .distance {
        margin-left: auto;
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 14px;
        color: #666;
        font-weight: 500;
    }
`;

export const TripPlanningCard = styled.div`
    padding: 12px;
    background: #f8f9fa;
    border-radius: 6px;
    border-left: 4px solid #667eea;
    margin-top: 8px;

    .card-title {
        font-weight: 600;
        color: #333;
        margin-bottom: 8px;
        font-size: 14px;
    }

    .planning-details {
        display: grid;
        gap: 6px;
        font-size: 13px;
        color: #555;
    }

    .detail-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .detail-value {
        font-weight: 600;
        color: #333;
    }
`;

export const PredictionsList = styled.div`
    max-height: 280px;
    overflow-y: auto;
    padding: 8px 0;
`;

export const PredictionItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid #f5f5f5;
    transition: background-color 0.2s ease;
    background: ${(props) => {
        if (props.isCanceled) return '#fff5f5';
        if (props.arriving) return '#f0f9ff';
        if (props.soon) return '#fffaf0';
        return 'transparent';
    }};

    &:hover {
        background: #f8f9fa;
    }

    .route-info {
        flex: 1;
        min-width: 0;
    }

    .route-header {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 4px;
    }

    .route-id {
        font-weight: 700;
        color: #333;
        font-size: 15px;
    }

    .status-indicator {
        font-size: 10px;
        font-weight: 600;
        padding: 2px 6px;
        border-radius: 10px;
        text-transform: uppercase;
        letter-spacing: 0.5px;

        &.live {
            background: #dcfce7;
            color: #166534;
        }

        &.scheduled {
            background: #fffbeb;
            color: #92400e;
        }

        &.canceled {
            background: #fef2f2;
            color: #dc2626;
        }
    }

    .destination {
        font-size: 13px;
        color: #666;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: 2px;
    }

    .agency {
        font-size: 11px;
        color: #888;
        font-weight: bold;
    }

    .arrival-info {
        text-align: right;
        min-width: 60px;
    }

    .minutes {
        font-weight: 700;
        font-size: 16px;
        color: ${(props) => {
            if (props.isCanceled) return '#dc2626';
            if (props.arriving) return '#059669';
            if (props.soon) return '#d97706';
            return '#6b7280';
        }};
    }

    .arrival-time {
        font-size: 11px;
        color: #888;
        margin-top: 2px;
    }
`;
export const LoadingState = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 20px;
    color: #666;

    .spin {
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
`;

export const ErrorState = styled.div`
    text-align: center;
    padding: 20px;
    color: #d32f2f;

    button {
        margin-top: 8px;
        background: #1976d2;
        color: white;
        border: none;
        padding: 8px 16px;
        border-radius: 4px;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 4px;

        &:hover {
            background: #1565c0;
        }
    }
`;

export const NoArrivalsState = styled.div`
    text-align: center;
    padding: 20px;
    color: #666;
`;
